<div class='subscriptions-container'>

  <h2> Tesseramento e Quota </h2>

  <app-product-list [configuration]='subscriptions'></app-product-list>

</div>
